import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfigService } from '../appconfig/appconfig.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import brandInfo from "src/environments/brand.json";
import { Observable, Subscription } from 'rxjs';
import { getOhioCancellationForm } from '../_actions/pdf.actions';

@Component({
  selector: 'app-view-cancellation',
  standalone: false,
  templateUrl: './view-cancellation.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrls: ['./view-cancellation.component.scss']
})
export class ViewCancellationComponent {
  branding: any;
  pdf$: Observable<any>;
  pdfSub: Subscription;
  src: any;
  pdf: any;
  
  constructor(
    private store: Store<{
      pdf: any
    }>,
    private route: ActivatedRoute,
    private appConfig: AppConfigService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const customerOrderNumber = this.route.snapshot.params['customerOrderNumber'];
      const state = this.route.snapshot.params['state'];
      const type = this.route.snapshot.queryParams['type'];
      

      const request: any = {
        viewType: type,
        customerOrderNumber: customerOrderNumber,
        state: state
      }

      this.store.dispatch(getOhioCancellationForm(request))
    })

    this.appConfig.getSettings().subscribe((result) => {
      this.branding = result;
    });

    this.pdf$ = this.store.select((store) => store.pdf);
    this.pdfSub = this.pdf$.subscribe((pdf) => {
      console.log('pdf', pdf)
      if (pdf) {
        if (pdf && pdf.success) {
          this.pdf = pdf.data;
          console.log('pdf is not null')
          this.src = this.sanitizer.bypassSecurityTrustResourceUrl("data:application/pdf;base64," + pdf.data);
          console.log('src', this.src)
        } else {
          this.pdf = null
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.pdfSub) {
      this.pdfSub.unsubscribe();
    }
  }

  downloadPDF() {
    const downloadLink = document.createElement("a");
    downloadLink.href = 'data:application/pdf;base64,' + this.pdf;
    downloadLink.download = "Ohio Cancellation Form.pdf";
    downloadLink.click();
  }
}
